import { Tabs } from '@/app/_core/domain/models/components/tabs/tabs.model';

export const TabsDemoCatalog: Tabs[] = [{ header: 'Tab One' }, { header: 'Tab Two' }, { header: 'Tab Three' }];
